export * from './status-fila-integracao.pipe';
